import { useState } from 'react'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'

const DropdownReview = () => {

  const [dropdownOpen,setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(prev => !prev);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down" >
      <DropdownToggle style={{ border: 'none', background: 'transparent' }}>
        <i className="bi-three-dots-vertical" style={{ color: 'black' }}></i>
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem>
             <h6 style={{ margin: 0, color: 'inherit' }}>delete</h6>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}

export default DropdownReview